import { useEffect, useRef } from 'react';

const AUTO_LOGOUT_TIME = 60 * 60 * 1000;

export default function AutoLogout({ logoutHandler }) {
  const timeoutRef = useRef();

  const resetTimer = () => {
    clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      logoutHandler();
    }, AUTO_LOGOUT_TIME);
  };

  useEffect(() => {
    const events = ['mousemove', 'keydown', 'click', 'scroll'];
    events.forEach(event => window.addEventListener(event, resetTimer));
    resetTimer();

    return () => {
      events.forEach(event => window.removeEventListener(event, resetTimer));
      clearTimeout(timeoutRef.current);
    };
  }, []);

  return null;
}
